import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from "react-leaflet";
import { useEffect } from "react";
import "leaflet/dist/leaflet.css";

function Fit({ points, center }) {
  const map = useMap();
  useEffect(() => {
    if (points.length > 1) map.fitBounds(points.map((p) => [p.lat, p.lng]), { padding: [30, 30], maxZoom: 13 });
    else if (center?.[0]) map.setView(center, 11);
  }, [points.length, center?.[0]]); // eslint-disable-line
  return null;
}

export default function JobMap({ jobs = [], pros = [], center, height = 360, onSelect, testid = "job-map" }) {
  const pts = [...jobs, ...pros].filter((p) => p.lat && p.lng);
  const c = center?.[0] ? center : pts[0] ? [pts[0].lat, pts[0].lng] : [-15.8, -47.9];
  return (
    <div data-testid={testid} className="map-dark overflow-hidden rounded-2xl border border-white/10" style={{ height }}>
      <MapContainer center={c} zoom={pts.length ? 10 : 4} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Fit points={pts} center={center} />
        {center?.[0] && <CircleMarker center={center} radius={9} pathOptions={{ color: "#3B82F6", fillColor: "#3B82F6", fillOpacity: 0.9 }}><Popup>Você</Popup></CircleMarker>}
        {jobs.filter((j) => j.lat).map((j) => (
          <CircleMarker key={j.id} center={[j.lat, j.lng]} radius={10} eventHandlers={{ click: () => onSelect?.(j) }}
            pathOptions={{ color: "#111317", weight: 2, fillColor: j.status === "assigned" ? "#FF5722" : "#FFC700", fillOpacity: 0.95 }}>
            <Popup><b>{j.title}</b><br />{j.city}{j.distance_km != null ? ` · ${j.distance_km} km` : ""}</Popup>
          </CircleMarker>
        ))}
        {pros.filter((p) => p.lat).map((p) => (
          <CircleMarker key={p.user_id} center={[p.lat, p.lng]} radius={7} pathOptions={{ color: "#111317", weight: 2, fillColor: "#10B981", fillOpacity: 0.9 }}>
            <Popup>{p.name}</Popup>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
}
